import { useSelector } from 'react-redux';
import { IAppState } from '@/store/root-reducer';
import { getMobileConfig } from '@/store/app-config/app-config.selectors';

export const useIsMobileDeviceView = () => ({
    isInMobileView: useSelector<IAppState, boolean>(state => getMobileConfig(state).isInMobileView),
    isInTabletView: useSelector<IAppState, boolean>(state => getMobileConfig(state).isInTabletView),
    isMobileDevice: useSelector<IAppState, boolean>(state => getMobileConfig(state).isMobileDevice),
});
